// HL-9781 §Phase 3: shared tier presentation helpers (Care+ tier names in checkout, reorder, My Account).

export type Translate = (key: string, fallback: string) => string;

export const tierName = (tier: string, t: Translate): string => {
  if (tier === "basic") return t("tier_care_plus", "Care+");
  if (tier === "pro") return t("tier_pro", "Pro");
  if (tier === "max") return t("tier_max", "Max");
  return tier;
};

// Marketing suffix appended after the "Care+" wordmark (e.g. "Care+ Pro", "Care+ Max").
// Empty for the base tier, which is just "Care+".
export const tierNameSuffix = (tier: string, t: Translate): string => {
  if (tier === "basic") return t("tier_name_basic_suffix", "");
  if (tier === "pro") return t("tier_name_pro_suffix", "Pro");
  if (tier === "max") return t("tier_name_max_suffix", "Max");
  return "";
};

// The customer-facing plan name: "Care+", "Care+ Pro", "Care+ Max". Built from the wordmark plus
// the tier suffix, so a new tier only needs its suffix key and an unknown tier degrades to a plain
// "Care+" rather than leaking the raw DB value into the UI.
export const tierFullName = (tier: string, t: Translate): string => {
  const suffix = tierNameSuffix(tier, t);
  return `${t("tier_care_suffix", "Care")}+${suffix ? ` ${suffix}` : ""}`;
};

export const tierDescription = (tier: string, t: Translate): string => {
  if (tier === "basic") return t("desc_basic", "Flexible treatment access with additional weight loss support");
  if (tier === "pro") return t("desc_pro", "More guidance, more support, better results.");
  if (tier === "max") return t("desc_max", "Care that goes further, every step of the way");
  return "";
};
